<!--
  관리자 설정
  관리자/그룹 편집 > SECUI OTP 설정

  @since 2021-02-25
  @author mk.ko
-->

<template>

  <layout-popup ref="layoutPopUp"
                :titleName="dialogTitleName"
                :footerBtn="dialogFooterButton"
                :confirmEvt="onConfirm"
                :authForce="true"
                @hide="onClose"
                :content-css="{minWidth: '460px', minHeight: '164px'}">
    <div class="content-group">
      <div class="contents-row">
        <table class="bs-table table-bordered-none">
          <colgroup>
            <col width="25%"/>
            <col width="auto"/>
          </colgroup>
          <tbody>
          <tr>
            <td class="td-head">OTP KEY<span class="textR">*</span></td>
            <td>
              <div class="inline-group">
                <q-input type="text"
                         :disable="isReadOnly"
                         align="center"
                         v-model="otp_key1"
                         ref="otp_key1"
                         maxlength="4"
                         name="otp_key1"
                         :error="errors.has('otp_key1')"
                         @input="onInputAddress($event, 0)"
                         @keydown="onKeyPrevent($event)"
                         v-validate="'required|isValidOtpKey'"
                         class="bs bs-q-input bs-q-input-default" style="width:70px;"
                >
                </q-input>
                <q-input type="text"
                         :disable="isReadOnly"
                         align="center"
                         v-model="otp_key2"
                         ref="otp_key2"
                         maxlength="4"
                         name="otp_key2"
                         :error="errors.has('otp_key2')"
                         @input="onInputAddress($event, 1)"
                         @keydown="onKeyPrevent($event)"
                         v-validate="'required|isValidOtpKey'"
                         class="bs bs-q-input bs-q-input-default" style="width:70px;"
                >
                </q-input>
                <q-input type="text"
                         :disable="isReadOnly"
                         align="center"
                         v-model="otp_key3"
                         ref="otp_key3"
                         maxlength="4"
                         name="otp_key3"
                         :error="errors.has('otp_key3')"
                         @input="onInputAddress($event, 2)"
                         @keydown="onKeyPrevent($event)"
                         v-validate="'required|isValidOtpKey'"
                         class="bs bs-q-input bs-q-input-default" style="width:70px;"
                >
                </q-input>
                <q-input type="text"
                         :disable="isReadOnly"
                         align="center"
                         v-model="otp_key4"
                         ref="otp_key4"
                         maxlength="4"
                         name="otp_key4"
                         :error="errors.has('otp_key4')"
                         @input="onInputAddress($event, 3)"
                         @keydown="onKeyPrevent($event)"
                         @keydown.enter="onConfirm"
                         v-validate="'required|isValidOtpKey'"
                         class="bs bs-q-input bs-q-input-default" style="width:70px;"
                >
                </q-input>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </layout-popup>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'

  import LayoutPopup from '~/components/popUp/LayoutModalPopUp'

  // TAMS
  const adminGroupSettingsHelpers = createNamespacedHelpers('system/adminSettings/adminGroupSettings')

  export default {
    name: 'AdminOtpPopup',
    components: {
      LayoutPopup
    },
    // TAMS
    props: {
      isReadOnly: {
        type: Boolean,
        default: false
      }
    },
    directives: {},
    mixins: [],
    data () {
      return {
        dialogTitleName: 'SECUI OTP',
        dialogFooterButton: ['confirm'],
        adm_id: '',
        otp_key: '', // TAMS
        otp_key1: '',
        otp_key2: '',
        otp_key3: '',
        otp_key4: ''
      }
    },
    computed: {
      ...adminGroupSettingsHelpers.mapState([
        'adminDetail'
      ])
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {},
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {},
    destroyed () {},
    errorCaptured () {},
    methods: {
      async hide () {
        this.$refs.layoutPopUp.hide()
      },
      async show (adminOtpKey = '') {
        this.otp_key = adminOtpKey // TAMS
        if (_.get(this.otp_key, ['length'], 0) > 0) {
          this.otp_key1 = this.otp_key.substr(0, 4)
          this.otp_key2 = this.otp_key.substr(4, 4)
          this.otp_key3 = this.otp_key.substr(8, 4)
          this.otp_key4 = this.otp_key.substr(12, 4)
        }
        this.$validator.reset()
        this.$refs.layoutPopUp.show()
      },
      async validate () {
        await this.validatorClear()
        const valOk = await this.validateMixins()
        if (valOk) {
          return true
        }
        return false
      },
      async onConfirm () {
        const validateOk = await this.validate()
        if (validateOk) {
          const adminOtpKey = _.concat(this.otp_key1, this.otp_key2, this.otp_key3, this.otp_key4).join('')
          this.$emit('confirm', adminOtpKey)
          this.$refs.layoutPopUp.hide()
        }
      },
      onClose () {
        this.otp_key = ''
        this.otp_key1 = ''
        this.otp_key2 = ''
        this.otp_key3 = ''
        this.otp_key4 = ''
        this.validatorClear()
      },
      onKeyPrevent: _.debounce(function (event) {
        const allowKeyCode = [8, 16, 35, 36, 46, 37, 38, 39, 40]
        if (_.indexOf(allowKeyCode, event.keyCode) !== -1) {
          return
        }
        let inputValue = event.target.value
        let regex = /[^0-9a-fA-F]/gi
        inputValue = (regex === '') ? inputValue : inputValue.replace(regex, '')
        let vName = event.target.name
        this[vName] = inputValue.toUpperCase()
      }, 50),
      onInputAddress (value, index) {
        let inputValue = value
        let regex = /[^0-9a-fA-F]/gi
        inputValue = (regex === '') ? inputValue : inputValue.replace(regex, '')
        if (inputValue.length === 4 && index < 3) {
          const keyindex = index + 1
          this['otp_key' + keyindex] = inputValue.toUpperCase()
          this.$el.getElementsByTagName('input')[index + 1].focus()
        }
        // 유효성 검사 딜레이 지정 후 수행
        const self = this
        setTimeout(function () {
          self.$validator.validateAll()
        }, 50)
      }
    },
    watch: {}
  }
</script>

<style scoped>

</style>
